import React from 'react';
import Dashboard from './Dashboard';
import GroceryManager from './GroceryManager';
import './GroceryPages.css';

const GroceryRetailPage = () => {
  return (
    <>
      <Dashboard />

      <div className="grocery-page-wrapper grocery-page-wrapper-clean">
        <div className="grocery-page-content-card grocery-page-content-card-clean">
          <GroceryManager mode="retail" title="Retail Product Panel" />
        </div>
      </div>
    </>
  );
};

export default GroceryRetailPage;
